import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WorkflowTypeSelect({
  objectTypeFilter = id => id !== UNKNOWN_ID,
  objectTypeId,
  onChange,
  readOnly,
  formControlProps,
  placeholder,
  noneOptionLabel
}) {
  const {
    loading,
    options: workflowTypeOptions,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs({
    objectTypeFilter
  });
  const noneOption = {
    text: noneOptionLabel !== null && noneOptionLabel !== void 0 ? noneOptionLabel : I18n.text('automation-ui-enrollment.workflowTypeSelect.noneOption'),
    value: UNKNOWN_ID,
    disabled: false
  };
  const isNoneValueAllowed = objectTypeFilter(noneOption.value);
  const select = /*#__PURE__*/_jsx(UISelect, {
    value: !isNoneValueAllowed && objectTypeId === UNKNOWN_ID ? undefined : objectTypeId,
    options: isNoneValueAllowed ? [noneOption, ...workflowTypeOptions] : workflowTypeOptions,
    onChange: ({
      target: {
        value
      }
    }) => {
      if (shouldSelectObjectType(value)) {
        onChange(value);
      }
    },
    isLoading: loading,
    readOnly: readOnly,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.workflowTypeSelect.placeholder"
    })
  });
  let control = select;
  if (formControlProps) {
    control = /*#__PURE__*/_jsx(FormControl, Object.assign({}, formControlProps, {
      children: select
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
      onClose: onCloseCustomModal
    }), control]
  });
}